import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://www.dein-imker.de';
const DEFAULT_IMAGE = `${BASE_URL}/images/og-image.jpg`;

const SeoHead = ({ title, description, path = '', image, type = 'website', structuredData }) => {
    const fullTitle = title.includes('dein-Imker') ? title : `${title} — dein-Imker.de`;
    const url = `${BASE_URL}${path}`;
    const ogImage = image || DEFAULT_IMAGE;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:site_name" content="dein-Imker.de" />
            <meta property="og:locale" content="de_DE" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />

            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SeoHead;
